<template>
  <div class="factoring-contract-list">
    <TableList
      ref="tableList"
      :tableConfig="tableConfig"
      :filterConfig="filterConfig"
      :queryListApi="queryListApi"
      :removeApi="removeApi"
      :detailUrl="detailUrl"
      :addNewUrl="addNewUrl"
      :exportUrl="exportUrl"
      :deleteEmit='true'
      addName="新建合同"
      addNameTwo="合同编号"
      :addNameTwoDisabled="disabled"
      @addNew="openSurveyList"
      @addNewTwo="openAddContractName"
      @deleteEmit="handleDelete"
      :menuButtonConfig="menuButtonConfig"
      slotStyle="color: #409eff"
    >
    </TableList>

    <el-dialog
      :close-on-click-modal="false" title="选择项目" :visible.sync="surveyDialogShow">
      <p class="dialog-tip">
        以下为尽调已通过的可选项目，请选择并开始创建合同：
      </p>
      <avue-crud
        id="dialogSurvey"
        :option="surveyTableConifg"
        :data="surveyData"
        :page.sync="page"
        @on-load="querySurveyData"
        @row-click="chooseSurvey"
        @sort-change="sortChange"
      ></avue-crud>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="合同编号"
      :visible.sync="contractNameVisible"
      :modal-append-to-body="false"
      width="40%"
    >
      <el-form
        ref="contractNameForm"
        :model="contractNameForm"
        label-width="80px"
      >
        <el-form-item
          label="保理合同"
          required
          prop="contractName"
          :rules="[{ required: true, message: '保理合同不能为空' }]"
        >
          <el-input
            v-model="contractNameForm.contractName"
            placeholder="输入内容"
          ></el-input>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button type="primary" @click="onSubmitContractName"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  querySurveyList,
  contractList,
  contractRemove,
  contractAdd,
  contractNameAdd,
} from "@/api/factoring/factoring";
import {
  contractTableConfig,
  surveyListConfig,
  contractFilterConfig,
} from "./contractConfig.js";
import TableList from "@/components/tableListComponents/table";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
import moment from "moment" 
export default {
  name: "FactoringContractList",
  mixins: [workFlow],
  data() {
    return {
      surveyData: [],
      surveyDialogShow: false,
      surveyTableConifg: surveyListConfig(this.getMoney),
      surveySelection: [],
      tableConfig: contractTableConfig(this.getMoney),
      filterConfig: contractFilterConfig(),
      queryListApi: contractList,
      removeApi: contractRemove,
      detailUrl: "/factoring/contractManage/contractDetail",
      addNewUrl: "/factoring/contractManage/addNewContract",
      exportUrl: "/api/bl/blcontractmanage/export",
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      menuButtonConfig: {
        addBtn: true,
        addBtnPermission:'factoringContractList_add',
        addBtnTwo: true,
        addBtnTwoPermission:'factoringContractList_edit',
        editBtn: false,
        deleteBtn: true,
        deleteBtnPermission:'factoringContractList_delete',
        exportBtn: true,
      },
      searchForm: {},
      contractNameVisible: false,
      contractNameForm: {
        contractName: null,
      },
      disabled: true,
      selectionList: [],
    };
  },
  components: {
    TableList,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    openAddContractName() {
      let selectionList = this.$refs.tableList.selectionList;
      if (selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (selectionList.length == 1) {
        let data = selectionList[0];
        this.virtualId = data.id;
        Object.assign(this.contractNameForm, {
          contractName: null,
        });
        this.contractNameVisible = true;
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    onSubmitContractName() {
      let that = this;
      this.$refs.contractNameForm.validate((vaild) => {
        if (vaild) {
          let data = {
            id: this.virtualId,
            ...this.contractNameForm,
          };
          contractNameAdd(data).then(
            (res) => {
              this.contractNameVisible = false;
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              that.$refs.tableList.queryTableData();
            },
            (error) => {
              window.console.log(error);
            }
          );
        }
      });
    },

    async handleDelete(selectionList) {
      let self = this
      let startDelete = () => {
        self.$confirm('确定删除选择的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.deleteData(selectionList)
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      if(selectionList.length > 1){
        this.$message.error('只能选择一条数据进行删除')
      } else if(selectionList.length == 1){
        if(selectionList[0].managerUser == this.userInfo.user_id || selectionList[0].assistUser == this.userInfo.user_id){
          let data = selectionList[0]
          
          if(data.flowableId != '' && data.auditStatus == 1) {
            // 获取流程数据
            await this.queryFlowData(data.flowableId)
            let presentFlow = this.flowData[this.flowData.length - 1]
            if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
              startDelete()
            }else {
              this.$message.error('流程审批中不能删除')
            }
          }else {
            // 直接弹框提示
            startDelete()
          }
        } else {
          this.$message.error('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData(selectionList) {
      let ids = selectionList.map((item) => {
        return item.id
      })
      let res = await contractRemove({ids: ids.join(',')})
      if(res.data.code == 200){
        this.$message.success('删除成功')
        // 刷新列表
        this.$refs.tableList.queryTableData();
      }
    },    

    openSurveyList() {
      this.surveyDialogShow = true;
    },

    async querySurveyData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        managerUser: this.userInfo.user_id,
        addContract:1,
        auditStatus:2,
      };
      let res = await querySurveyList(params);
      if (res.data.code == 200) {
        let surveyData = res.data.data.records.map(item=>{
          return {
            ...item,
            surplusQuota: Number(item.factoringCredit)-Number(item.contractSumAlready)
          }
        });

        this.surveyData=surveyData
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //排序
    sortChange(val) {
      this.searchForm.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.searchForm.orderName = val.prop;
      this.page.currentPage = 1;
      this.querySurveyData();
    },
    async chooseSurvey(row) {
      this.surveyDialogShow = false;
      this.$router.push({
        path: `/factoring/contractManage/contractDetail/0`,
        query: {
          reportId: row.id,
        },
      });

      // let res = await contractAdd({ reportId: row.id });
      // if (res.data.code == 200) {
      //   this.surveyDialogShow = false;
      //   this.$router.push({
      //     path: `/factoring/contractManage/contractDetail/${res.data.data.id}`,
      //   });
      // } else {
      //   this.$message.error(res.data.msg);
      // }
    },
    //点击行跳转详情
    handleRowClick(row, event, column) {
      this.$router.push({
        path: `/factoring/buildProject/projectDetail/${row.id}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-contract-list {
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }  
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;

    .messagetitle {
      font-weight: bolder;
    }
  }

  .project-table {
    background: #ffff;
    padding: 25px;
  }

  .project-name {
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }

  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}

#dialogSurvey {
  /deep/ .avue-crud__search {
    display: none !important;
  }

  /deep/ .avue-crud__menu {
    display: none !important;
  }

  /deep/ .el-table__row {
    cursor: pointer;
  }
}
</style>
